module.exports = __webpack_public_path__ + "img/add-group.7d59691b.svg";